export default {
    noEvent: 'No event found',
    noEventDesc: 'Please log in again.',
    noLocation: 'Location not defined',
    guestList: 'Guest List',
    guestListDesc: 'See who is attending the event.',
    tasks: 'Tasks',
    tasksDesc: 'View schedule and to-do tasks.',
    budget: 'Budget',
    budgetDesc: 'View estimated budget.',
    welcomeTitle: 'Welcome to your guest space',
    welcomeDesc: 'Here you can view event information and see the guest list. More features coming soon!'
};
